import { jsx as i } from "react/jsx-runtime";
import { c as p } from "../clsx-OuTLNxxd.js";
import { c as t } from "../background-bUl5ds8G.js";
const m = "Chip-module_chip__3f0zv",
  a = {
    chip: m
  },
  e = _ref => {
    let {
      children: s,
      className: c,
      background: o
    } = _ref;
    const r = t(o);
    return /* @__PURE__ */i("div", {
      className: p(a.chip, c, r),
      children: s
    });
  };
export { e as Chip };